import { Button, Form } from "react-bootstrap";
import { useCallback, useMemo, useState } from "react";
import { PartnerCampaignFormWrapperStyled } from "./styled/PartnerCampaignsStyled";
import { formReferralLink } from "../partnerUtils";
import { sanitizeLettersNumbersUnderscore } from "../../../utils/escapeUtils";
import CopyReferralLink from "../components/CopyReferralLink/CopyReferralLink";
import PartnerPostbacks from "../PartnerPostbacks/PartnerPostbacks";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";

export const PartnerCampaignForm = (props) => {
    const {
        campaignId,
        onSubmit,
        onCancel,
        onDelete,
        nameDefaultValue = '',
        channelDefaultValue = '',
        refshare,
        postbacksList,
    } = props;
    const {getLangPath} = useLangContext();
    const [campaignName, setCampaignName] = useState(nameDefaultValue);
    const [campaignChannel, setCampaignChannel] = useState(channelDefaultValue);

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        onSubmit({
            campaign_name: campaignName,
            campaign_channel: campaignChannel,
        });
    }, [campaignChannel, campaignName, onSubmit]);

    const handleChangeCampaignChannel = useCallback((e) => {
        setCampaignChannel(sanitizeLettersNumbersUnderscore(e.currentTarget.value));
    }, []);

    const handleChangeCampaignName = useCallback((e) => {
        setCampaignName(sanitizeLettersNumbersUnderscore(e.currentTarget.value));
    }, []);

    const referralLink = useMemo(() => formReferralLink({
        refshare,
        campaign: campaignName,
        channel: campaignChannel
    }), [campaignChannel, campaignName, refshare]);

    return <PartnerCampaignFormWrapperStyled>
        <Form onSubmit={handleSubmit} className="p-3">
            <div className="d-flex flex-lg-row flex-column">
                <Form.Group className="flex-grow-1 me-lg-3">
                    <Form.Label>{getLangPath('partner.campaign_name')}</Form.Label>
                    <Form.Control
                            type="text"
                            name="campaign_name"
                            placeholder={getLangPath('partner.campaign_name')}
                            value={campaignName}
                            required
                            onChange={handleChangeCampaignName}
                    />
                </Form.Group>

                <Form.Group className="flex-grow-1 mt-3 mt-lg-0">
                    <Form.Label>{getLangPath('partner.campaign_channel')}</Form.Label>
                    <Form.Control
                            type="text"
                            name="campaign_channel"
                            placeholder={getLangPath('partner.campaign_channel')}
                            onChange={handleChangeCampaignChannel}
                            value={campaignChannel}
                    />
                </Form.Group>
            </div>

            {
                !!postbacksList && <div className="my-4">
                    <Form.Label>{getLangPath('partner.postbacks.title')}</Form.Label>
                    <PartnerPostbacks postbacksList={postbacksList} campaignId={campaignId}/>
                </div>
            }

            <div className="d-flex align-items-center">
                <p className="mt-3 me-3">{getLangPath('partner.campaigns.campaign_referral_link')}</p>
            </div>
            <div className="d-flex justify-content-start align-items-center mb-4">
                <h5 className="mb-0 me-3">{referralLink}</h5>
                <CopyReferralLink referralLink={referralLink}/>
            </div>

            <div className="d-flex justify-content-between mt-3">
                <div className="d-flex">
                    <Button variant="primary" size='md' type="submit">
                        {getLangPath('partner.campaigns.save')}
                    </Button>
                    <Button variant="info" size='md' onClick={onCancel} className="ms-3">
                        {getLangPath('partner.campaigns.cancel')}
                    </Button>
                </div>
                {
                        !!onDelete && <Button variant="danger" size='md' onClick={onDelete} className="ms-3">
                            {getLangPath('partner.campaigns.delete_campaign')}
                        </Button>
                }
            </div>
        </Form>
    </PartnerCampaignFormWrapperStyled>
}
